import {Route} from '@angular/router';

import {routeNames} from '../route-names';
import {UserModel} from '../../models/user.model';
import {RoutesRules} from '../../interfaces/routes-rules';
import {UserRole} from "../../enums/user-role.enum";

export class PermissionHelper {
    // Use properties 'forbiddenRoles' or 'allowedRoles' to define user page access.
    // Use property 'forbiddenRoles' to deny access to user having those specifics roles :
    // { routepath: routeNames.home, forbiddenRoles: [RoleHelper.PARTNER] },
    // Use property 'allowedRoles' to give access only to user having those specifics roles :
    // { routepath: routeNames.home, allowedRoles: [RoleHelper.OWNER, RoleHelper.ADMIN, RoleHelper.SUPERADMIN] },

    static readonly routesRules: RoutesRules[] = [
        {
            routepath: routeNames.home
        },
        {
            routepath: routeNames.administration,
            allowedRoles: [UserRole.SUPER_ADMIN, UserRole.CHIEF_INSPECTOR]
        },
        {
            routepath: routeNames.userManagement,
            allowedRoles: [UserRole.SUPER_ADMIN, UserRole.CHIEF_INSPECTOR]
        },
        {
            routepath: routeNames.sitesManagement,
            allowedRoles: [UserRole.SUPER_ADMIN]
        },
        {
            routepath: routeNames.translations,
            allowedRoles: [UserRole.SUPER_ADMIN]
        },
        {
            routepath: routeNames.howItWorks,
        },
    ];

    static canUserActivate(user: UserModel, route: Route) {
        const routeRule = this.routesRules.find((r) => r.routepath === route.path);
        if (routeRule) {
            if (routeRule.forbiddenRoles && routeRule.forbiddenRoles.length > 0) {
                return this.hasNotRole(user, routeRule.forbiddenRoles);
            } else if (routeRule.allowedRoles && routeRule.allowedRoles.length > 0) {
                return this.hasAnyRole(user, routeRule.allowedRoles);
            } else {
                return true;
            }
        }
        return true;
    }

    static isAdmin(user: UserModel): boolean {
        return user.role !== null && user.role === UserRole.SUPER_ADMIN;
    }

    static hasAnyRole(user: UserModel, rolesList: string[]) {
        return user.role && rolesList.includes(user.role);
    }

    static hasNotRole(user: UserModel, rolesList: string[]) {
        return user.role && !rolesList.includes(user.role);
    }

    static canDeleteEquipment(user: UserModel | null): boolean {
        if (!user || !user.role) {
            return false;
        }
        return this.hasAnyRole(user, [
            UserRole.CHIEF_INSPECTOR,
            UserRole.SUPER_ADMIN
        ]);
    }

    static canModifyPoint(user: UserModel | null): boolean {
        if (!user || !user.role) {
            return false;
        }
        return this.hasAnyRole(user, [
            UserRole.CHIEF_INSPECTOR,
            UserRole.SUPER_ADMIN,
            UserRole.INSPECTOR
        ]);
    }
}
